export default {
  app: {
    version: process.env.REACT_APP_VERSION,
  },
  apiGateway: {
    checks: {
      URL: process.env.REACT_APP_COREAPI_URL,
      REGION: process.env.REACT_APP_AWS_REGION,
    },
    incomes: {
      URL: process.env.REACT_APP_COREAPI_URL,
      REGION: process.env.REACT_APP_AWS_REGION,
    },
    profiles: {
      URL: process.env.REACT_APP_COREAPI_URL,
      REGION: process.env.REACT_APP_AWS_REGION,
    },
    tac: {
      URL: process.env.REACT_APP_COREAPI_URL,
      REGION: process.env.REACT_APP_AWS_REGION,
    },
  },
  cognito: {
    USER_POOL_ID: process.env.REACT_APP_COGNITO_USER_POOL_ID,
    APP_CLIENT_ID: process.env.REACT_APP_COGNITO_APP_CLIENT_ID,
    REGION: process.env.REACT_APP_COGNITO_REGION,
    IDENTITY_POOL_ID: process.env.REACT_APP_COGNITO_IDENTITY_POOL_ID,
  },
  s3: {
    BUCKET: process.env.REACT_APP_S3_BUCKET,
    REGION: process.env.REACT_APP_S3_REGION,
  },
  bugSnag: {
    API_KEY: process.env.REACT_APP_BUGSNAG_API_KEY,
    RELEASE: process.env.REACT_APP_BUGSNAG_RELEASE,
  },

  MAX_ATTACHMENT_SIZE: 5000000,
};



// WEBPACK FOOTER //
// ./src/config.js